module.exports = __webpack_public_path__ + "img/rightSide@2x.df4508f.jpg";